import './Loading.scss';

import clsx from 'clsx';
import { memo } from 'react';

import Icon from '../Image/Image';

type LoadingProps = { className?: string };

const Loading = memo(
  ({ className }: LoadingProps) => (
    <main className={clsx(`loading-page`, className)}>
      <Icon name="Loading" className="flex loading-icon" />
    </main>
  ),
  (prev, next) => prev.className === next.className,
);

export default Loading;
